export default "__VITE_ASSET__DrBMfXPT__"